import { postListFetcher } from '@/shared/api/list';
import { formatCost } from '@/shared/lib/datetime';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';

interface Markup extends ListRow {
  from?: number;
  to?: number;
  customer?: number;
  service?: number;
  auto_park?: number;
}

const config: ListPageConfig<Markup> = {
  queryKey: 'parts-markups',
  title: 'Базовые наценки',
  errorText: 'Ошибка загрузки наценок',
  fetchList: postListFetcher('/part/markup/list/'),
  rows: ['markups'],
  paginated: false,
  columns: [
    { header: '№', render: (_, { number }) => number },
    { header: 'from', render: (markup) => `${formatCost(markup.from)} ₽` },
    { header: 'to', render: (markup) => `${formatCost(markup.to)} ₽` },
    { header: 'customer', render: (markup) => `${markup.customer} %` },
    { header: 'service', render: (markup) => `${markup.service} %` },
    { header: 'auto_park', render: (markup) => `${markup.auto_park} %` },
  ],
};

export const MarkupsPage = () => <GenericListPage config={config} />;
